import styled, { css } from 'styled-components';

export const Tabsection = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  gap: 25px;
  justify-content: start;
  margin: 0 -40px;
  padding: 0 40px;
  border-bottom: ${({ theme }) =>
    `2px solid ${theme.colors.border.secondaryLight}`};
`;
export const TitleTag = styled.div`
  padding: 5px 10px;
  border-bottom: 2px solid;
  border-color: ${({ active, theme }) =>
    active ? theme.colors.main.primary : theme.colors.border.secondaryLight};
  position: relative;
  top: 2px;
  cursor: pointer;
`;
export const InfoMapSection = styled.div`
  display: grid;
  grid-template-columns: 462px 1fr;
`;
export const InfoSection = styled.div`
  padding: 20px 20px 0;
`;

export const LocationItem = styled.div`
  margin: 5px 0 0 45px;
  padding: 6px;
  display: flex;
  align-items: center;
  gap: 10px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  background-color: ${({ active, theme }) =>
    active ? theme.colors.sidebarActiveBackgroundColor : 'transparent'};
  color: ${({ active, theme }) =>
    active ? theme.colors.main.primary : 'inherit'};
  font-weight: ${({ active }) => (active ? '600' : '500')};
  border: ${({ active, theme }) =>
    active
      ? `1px solid ${theme.colors.main.primary}`
      : '1px solid transparent'};
  border-left: ${({ active, theme }) =>
    active
      ? `3px solid ${theme.colors.main.primary}`
      : '3px solid transparent'};

  &:hover {
    background-color: ${({ theme }) =>
      theme.colors.sidebarActiveBackgroundColor};
  }
`;

export const LocationRegion = styled.span`
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  margin-left: 8px;
  background-color: ${({ theme }) => theme.colors.main.primaryLight};
  color: ${({ theme }) => theme.colors.main.primary};
`;
